// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const sid = "mlmcvumygnkoretikwpy";

export const environment = {
  production: false,
  supabaseUrl: 'https://' + sid + '.supabase.co',
  supabaseKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1sbWN2dW15Z25rb3JldGlrd3B5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDc3MzE1NjYsImV4cCI6MjAyMzMwNzU2Nn0.J-LgLoBBQ7soq38UlMiD1gp8XyANeGGeBbrwYcL6tTc',
  SettingsExpiretime: 600000 // 10*60*1000 = 10 minutes
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
